/**
 * Central API configuration. Change base URL here when switching to C# backend.
 * In development we always use /api so the Vite proxy forwards to the backend (avoids
 * browser/Kaspersky blocking direct requests to localhost:44321). In production,
 * `VITE_API_BASE_URL` overrides; otherwise the default points at the deployed ABP host
 * (frontend on a different IIS server must call the API by absolute URL).
 *
 * Backend CORS (`App:CorsOrigins`) must include the SPA origin, e.g. `https://52.4.220.108`.
 */
const isDev = import.meta.env.DEV;

/** Default when frontend and backend are split; override per environment with VITE_API_BASE_URL. */
const defaultProductionApiBase = 'https://psb-test.mehe.gov.lb/api';

const productionBaseUrl =
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim() || defaultProductionApiBase;

export const apiConfig = {
  /** Base URL for API requests. Dev: `/api` (Vite proxy). Prod: env or default production host + `/api`. */
  baseUrl: isDev ? '/api' : productionBaseUrl,
  /** localStorage key for the access token. Change to use cookies if needed. */
  authAccessTokenKey: 'auth:accessToken',
} as const;
